import { render, staticRenderFns } from "./ImportPaiDocument.vue?vue&type=template&id=4e96d483&scoped=true&"
import script from "./ImportPaiDocument.vue?vue&type=script&lang=js&"
export * from "./ImportPaiDocument.vue?vue&type=script&lang=js&"
import style0 from "./ImportPaiDocument.vue?vue&type=style&index=0&id=4e96d483&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96d483",
  null
  
)

export default component.exports